<!-- 编辑商品 -->

<template>
  <a-modal v-model:visible="visible" :title="title" :maskClosable="false" :width="item ? '1200px' : '600px'">
    <template #footer>
      <a-button key="back" type="primary" @click="save" :loading="saveLoading">保存</a-button>
      <a-button key="back" type="primary" @click="isShowLogModal = true">当前日志</a-button>
      <a-button key="back" @click="handleCancel">关闭</a-button>
    </template>
    <div v-if="!item">
      <a-radio-group v-model:value="goodsChangeType" button-style="solid">
        <a-radio-button value="1">根据页码操作</a-radio-button>
        <a-radio-button value="2">根据商品ID操作</a-radio-button>
      </a-radio-group>
    </div>

    <div class="set_header">
      <div v-if="goodsChangeType == '1'" class="set_box">
        请输入需要执行的页码：第1页到第 <a-input-number size="small" :min="1" v-model:value="pageNo" />页
      </div>
      <div class="set_box">
        <a-checkbox v-model:checked="editPrice"></a-checkbox>
        批量设置价格：原价*
        <a-input-number :min="0" v-model:value="changePrice1" size="small" @change="editPrice = true" />+
        <a-input-number :min="0" v-model:value="changePrice2" size="small" @change="editPrice = true" />
        <!-- <a-button @click="editPrice = !editPrice" type="primary" size="small">{{
          !editPrice ? "设置" : "取消设置"
        }}</a-button> -->
      </div>
      <div class="set_box">
        <a-checkbox v-model:checked="editStock"></a-checkbox>
        批量设置库存：库存*<a-input-number
          :min="0"
          v-model:value="changeStock1"
          size="small"
          @change="editStock = true"
        />+
        <a-input-number :min="0" v-model:value="changeStock2" size="small" @change="editStock = true" />
        <!-- <a-button @click="editStock = !editStock" type="primary" size="small">{{
          !editStock ? "设置" : "取消设置"
        }}</a-button> -->
      </div>
    </div>
    <Table v-if="item" :info="tableInfo" @changePage="changePage" @selectChange="selectChange($event)">
      <template #SKU="{ record }">
        <div v-if="record" class="good_info2">
          {{ record.SkuId }}
        </div>
      </template>

      <template #SKU_Name="{ record }">
        <div class="good_info2">
          {{ record.ExtInfos.SkuName }}
        </div>
      </template>
      <template #price="{ record }">
        <div class="good_info2">
          {{ (record.Price / 100).toFixed(2) }}
        </div>
      </template>
      <template #changePrice="{ record }">
        <div class="good_info2">
          {{ editPrice ? ((record.Price * changePrice1 + changePrice2 * 100) / 100).toFixed(2) : "未设置" }}
        </div>
      </template>

      <template #stock="{ record }">
        <div class="good_info2">
          {{ record.Stock }}
        </div>
      </template>
      <template #changeStock="{ record }">
        <div class="good_info2">
          {{ editStock ? record.Stock * changeStock1 + changeStock2 : "未设置" }}
        </div>
      </template>
    </Table>
    <a-modal
      class="move-log-modal"
      v-model:visible="isShowLogModal"
      width="900px"
      style="top: 35px"
      :maskClosable="false"
    >
      <template #title>
        <div style="margin-bottom: 3px">修改日志</div>
        <MoveSteps :current="2" />
      </template>
      <LogModal ref="logModal" strType="p" />
      <template #footer>
        <a-button type="primary" ghost @click="isShowLogModal = false">关闭窗口</a-button>
        <slot name="footer" />
      </template>
    </a-modal>
  </a-modal>
</template>

<script>
import { getProductInfo, marketProductEdit, getProductList } from "../../good_manage_api";
import { message } from "ant-design-vue";
import LogModal from "@/views/base/components/log_modal/log_modal";
//marketProductEdit
export default {
  components: { LogModal },
  data() {
    return {
      isShowLogModal: false,
      goodsChangeType: "2",
      title: "",
      item: null,
      itemInfo: null, //单个商品详情
      saveLoading: false,
      changePrice1: 1, //倍率
      changePrice2: 0, //固定值
      changeStock1: 1, //倍率
      changeStock2: 0, //固定值
      pageNo: 1,
      pageSize: 100,
      editPrice: false,
      editStock: false,
      selectGoods: [], //外面选中的商品数据
      selectGoods2: [], //分页商品数据
      goodsInfoList: [], //原始数据
      goodsInfoListChange: [], //修改后数据
      visible: false,
      tableInfo: {
        page: 1,
        pageSize: 10000,
        showTotal: (total) => `共 ${total} 条`,
        hideOnSinglePage: true,
        pageSizeOptions: ["20", "50", "100"],
        list: [],
        total: 0,
        tableScroll: { x: "800px", y: "calc(100vh - 430px)" },
        loading: false,
        columns: [
          {
            title: "SKU",

            slots: { customRender: "SKU" },
          },

          {
            title: "SKU名称",

            slots: { customRender: "SKU_Name" },
          },
          {
            title: "价格",

            slots: { customRender: "price" },
          },
          {
            title: "改后价格预览",

            slots: { customRender: "changePrice" },
          },
          {
            title: "库存",

            slots: { customRender: "stock" },
          },
          {
            title: "改后库存预览",

            slots: { customRender: "changeStock" },
          },
        ],
        rowSelection: { columnTitle: "全选" },
        selectedRowKeys: [],
        selectedRows: [],

        renderSlot: ["SKU", "SKU_Name", "price", "changePrice", "stock", "changeStock"],
        rowKey: "SkuId",
      },
    };
  },
  methods: {
    //入口
    open(item, selectGoods, pageSize) {
      this.pageSize = pageSize;
      this.editPrice = false;
      this.editStock = false;
      this.tableInfo.selectedRowKeys = [];
      this.tableInfo.selectedRows = [];
      this.changePrice1 = 1;
      this.changePrice2 = 0;
      this.changeStock1 = 1;
      this.changeStock2 = 0;
      this.selectGoods = [];
      this.goodsChangeType = "2";
      this.pageNo = 1;
      this.item = null;
      this.itemInfo = null;
      console.log(selectGoods);
      this.queryParams = { title: "", itemId: "" };
      if (item) {
        this.item = item;
        this.getGoodsData(this.item);
      } else {
        this.selectGoods = selectGoods;
      }

      this.visible = true;
    },

    //关闭方法
    handleCancel() {
      this.visible = false;
    },
    //保存设置的价格和库存
    async save() {
      this.isShowLogModal = true;
      this.$nextTick(async () => {
        this.$refs.logModal.clear();
        this.$refs.logModal.addLog(`正在查询商品详情，请耐心等待...`);
        this.saveLoading = true;
        this.goodsInfoList = [];
        this.goodsInfoListChange = [];
        //按页面获取商品详情
        if (!this.item && this.goodsChangeType == 1) {
          const query = {
            page: 1,
            size: this.pageSize * this.pageNo,
            publicStatus: 1,
          };

          const { result } = await getProductList(query);
          this.selectGoods2 = result.Data || result.Datas;
          //保存多选的商品
          if (this.selectGoods2.length > 0) {
            for (let i = 0; i < this.selectGoods2.length; i++) {
              await this.getGoodsData(this.selectGoods2[i]);
            }
          }
        }
        //保存多选的商品
        if (!this.item && this.selectGoods.length > 0 && this.goodsChangeType == 2) {
          for (let i = 0; i < this.selectGoods.length; i++) {
            await this.getGoodsData(this.selectGoods[i]);
          }
        }
        //设置单个商品
        if (this.item) {
          this.goodsInfoList.push({
            title: this.itemInfo.Title,
            itemId: this.itemInfo.ItemId,
            editPrice: this.editPrice,
            editStock: this.editStock,
            skuList: this.tableInfo.selectedRows,
          });
        }
        //修改每一个商品的sku
        for (let i1 = 0; i1 < this.goodsInfoList.length; i1++) {
          if (this.goodsInfoList[i1].skuList) {
            const skuList = [];
            for (let i2 = 0; i2 < this.goodsInfoList[i1].skuList.length; i2++) {
              if (this.editPrice) {
                this.goodsInfoList[i1].skuList[i2].price =
                  this.goodsInfoList[i1].skuList[i2].Price * this.changePrice1 + this.changePrice2 * 100;
              }
              if (this.editStock) {
                this.goodsInfoList[i1].skuList[i2].stock =
                  this.goodsInfoList[i1].skuList[i2].Stock * this.changeStock1 + this.changeStock2 * 100;
              }
              skuList.push({
                skuId: this.goodsInfoList[i1].skuList[i2].SkuId,
                price: this.goodsInfoList[i1].skuList[i2].price,
                stock: this.goodsInfoList[i1].skuList[i2].stock,
              });
            }
            const infoChange = { ...this.goodsInfoList[i1], skuList: skuList };
            this.goodsInfoListChange.push(infoChange);
          }
        }
        //编辑每一个商品
        for (let j = 0; j < this.goodsInfoListChange.length; j++) {
          this.$refs.logModal.addLog(`正在设置${this.goodsInfoListChange[j].title}价格库存，请耐心等待...`);
          await marketProductEdit({ content: JSON.stringify(this.goodsInfoListChange[j]) });
          this.$refs.logModal.addLog(`${this.goodsInfoListChange[j].title}价格库存设置完成`);
        }
        message.success("修改完成");
        this.saveLoading = false;
      });
    },
    //获取商品数据
    async getGoodsData(goods) {
      const query = {
        itemId: goods.ItemId,
      };
      if (this.isShowLogModal) {
        this.$refs.logModal.addLog(`正在查询${goods.Title}sku信息，请耐心等待...`);
      }

      await getProductInfo(query)
        .then((res) => {
          this.itemInfo = res.result;
          this.goodsInfoList.push({
            title: res.result.Title,
            itemId: res.result.ItemId,
            editPrice: this.editPrice,
            editStock: this.editStock,
            skuList: res.result.SkuList,
          });
          if (this.isShowLogModal) {
            this.$refs.logModal.addLog(`${goods.Title}查询完成`);
          }

          this.tableInfo.list = res.result.SkuList;
        })
        .catch(() => {});
    },

    //切换分页配置
    changePage(page, size) {
      this.tableInfo.page = page;
      this.tableInfo.pageSize = size;
      this.getGoodsData();
    },
    //搜索
    search(itemId) {
      itemId && (this.queryParams.itemId = itemId);
      this.queryParams.itemId && (this.queryParams.itemId = this.queryParams.itemId.replace(/\s/g, ""));
      this.getGoodsData();
    },
    //选中
    selectChange(e) {
      console.log(e);
      console.log(this.tableInfo.selectedRowKeys);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.set_box {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.good_info2 {
  text-align: center;
}
.good_info {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .good_img {
    width: 75px;
    height: 75px;
  }
  .good_text {
    text-align: left;
    cursor: pointer;
    .good_goto {
      color: #007fff;
    }
  }
}
</style>
